import React from "react";
import axios from "axios";
import * as emailjs from "emailjs-com";
import Noty from "noty";
import * as EmailValidator from "email-validator";

class Home extends React.Component {
  componentDidMount() {
    this.forceUpdate();
  }
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      msg_subject: "",
      email: "",
      message: "",
    };
  }
  handleFormSubmit(event) {
    event.preventDefault();
    let templateParams = {
      from_name: this.state.email,
      to_name: this.state.name,
      subject: this.state.msg_subject,
      message_html: this.state.message,
    };
    if (this.state.email) {
      let emailValid = EmailValidator.validate(this.state.email);
      if (emailValid && this.state.name && this.state.message) {
        let res = axios
          .get(
            "http://localhost:3001/users/" +
              templateParams.from_name +
              "/" +
              templateParams.to_name +
              "/" +
              templateParams.subject +
              "/" +
              templateParams.message_html +
              ""
          )
          .then((resp) => console.log(resp));
        if (res) {
          new Noty({
            text: "email is sent !!",
            type: "success",
            animation: {
              open: "animated bounceInRight", // Animate.css class names
              close: "animated bounceOutRight", // Animate.css class names
            },
          }).show();
        }
      } else if (!emailValid) {
        setTimeout(function () {
          new Noty({
            text: "Verify youre email please !!",
            type: "error",
            animation: {
              open: "animated bounceInRight", // Animate.css class names
              close: "animated bounceOutRight", // Animate.css class names
            },
          }).show();
        }, 500);
      }
    } else if (
      !this.state.name &&
      !this.state.msg_subject &&
      !this.state.message
    ) {
      setTimeout(function () {
        new Noty({
          text: "Please  add all the fields!!",
          type: "error",
          animation: {
            open: "animated bounceInRight", // Animate.css class names
            close: "animated bounceOutRight", // Animate.css class names
          },
        }).show();
      }, 500);
    }
  }
  render() {
    return (
      <div>
        <div id="hero-area" className="hero-area-bg">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="contents text-center">
                  <h2 className="head-title ">
                    Timesheet tracking for Jira <br />
                  </h2>
                  <h4 className="under-title ">
                    Smart reports for your project
                    <br />
                  </h4>
                  <div
                    className="header-button wow fadeInUp"
                    data-wow-delay="0.3s"
                  >
                    <a
                      href="https://marketplace.atlassian.com/apps/1216988/timesheet-tracking-for-jira?hosting=cloud&tab=overview"
                      target="_blank"
                      className="r-button ai-element ai-element_type3 ai-element6"
                      style={{ textDecoration: "none" }}
                    >
                      <span className="ai-element__label">Start right now</span>
                    </a>
                  </div>
                </div>
                <div
                  className="img-thumb text-center wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <img
                    style={{ height: "auto", width: "100%" }}
                    src="assets/img/hero-1.png"
                    alt="plugin jira timesheets free"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="feature">
          <div className="container-fluid">
            <div className="row">
              <div
                style={{ backgroundColor: "#fafafa" }}
                className="col-lg-6 col-md-12 col-sm-12"
              >
                <div className="text-wrapper">
                  <div>
                    <h2
                      className="title-hl wow fadeInLeft"
                      data-wow-delay="0.3s"
                    >
                      Top trending <br />
                    </h2>
                    <p className="mb-4">
                      Timesheets is a huge success in the server version with
                      more than 5900 active installations so far. It was awarded
                      as one of the best trending apps by Idalko an Atlassian
                      platinum partner. Timesheets is also on the top trending
                      apps on the marketplace for several months.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 padding-none feature-bg">
                <div className="feature-thumb">
                  <div
                    className="feature-item wow fadeInDown"
                    data-wow-duration="1000ms"
                    data-wow-delay="300ms"
                  >
                    <div className="icon">
                      <i className="lni-microphone"></i>
                    </div>
                    <div className="feature-content">
                      <h3>About Timesheets</h3>
                      <p>
                        By simple filtering,you can generate pie charts or
                        tables to get a look to your people worklogs or projects
                        duration costs. You can customize any fields to focus on
                        groups, users or precise projects.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section id="services" className="section-padding bg-gray">
          <div className="container">
            <div className="section-header text-center">
              <h2
                className="section-title wow fadeInDown"
                data-wow-delay="0.3s"
              >
                Always on the top !
              </h2>
              <p>
                Top 1 Trending Time tracking apps this week !! <br />
                Simple time-sheets reports based on users and projects
              </p>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-4 col-xs-12">
                <div
                  className="services-item wow fadeInRight"
                  data-wow-delay="0.3s"
                >
                  <div className="icon">
                    <i className="lni-pencil"></i>
                  </div>
                  <div className="services-content">
                    <h3>
                      <a href="#">easy-to-use timesheets reports</a>
                    </h3>
                    <p>
                      Generate your timesheet reports effortlessly. The ability
                      to add additional fields to the report. Customization of
                      the report.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xs-12">
                <div
                  className="services-item wow fadeInRight"
                  data-wow-delay="0.6s"
                >
                  <div className="icon">
                    <i className="lni-briefcase"></i>
                  </div>
                  <div className="services-content">
                    <h3>
                      <a href="#">Simple yet effective filters </a>
                    </h3>
                    <p>
                      Customize your request with various parameters as the
                      users, the projects, the filters and more. You can also
                      display the resulting JQL.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xs-12">
                <div
                  className="services-item wow fadeInRight"
                  data-wow-delay="0.9s"
                >
                  <div className="icon">
                    <i className="lni-cog"></i>
                  </div>
                  <div className="services-content">
                    <h3>
                      <a href="#">Check users & projects details</a>
                    </h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Unde perspiciatis dicta labore nulla beatae quaerat quia
                      incidunt laborum aspernatur...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="testimonial" className="testimonial section-padding">
          <div className="overlay"></div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <div
                  id="testimonials"
                  className="owl-carousel wow fadeInUp"
                  data-wow-delay="1.2s"
                >
                  <div className="item">
                    <div className="testimonial-item">
                      <div>
                        <div className="shot-item">
                          <img
                            src="assets/img/blog/chart.png"
                            alt=" timesheets plugin jira"
                          />
                          <div className="single-content">
                            <div className="fancy-table">
                              <div className="table-cell">
                                <div className="zoom-icon">
                                  <a
                                    className="lightbox"
                                    href="assets/img/blog/chart.png"
                                  >
                                    <i className="lni-eye item-icon"></i>
                                  </a>
                                </div>
                                <p>Charts</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="info">
                        <h2>
                          <p>Charts</p>
                        </h2>
                      </div>
                      <div className="content">
                        <p className="description">
                          You can click on charts sections to generate
                          sub-tables with issues or projects links . You can
                          also click directly on the name of the section (The
                          list on the right side on each chart) Pie chart on the
                          left gives you a quick overview on users participation
                          to projects . By clicking on one section, a table with
                          the list of issues will be generated. Pie chart on the
                          right gives you an overview of projects costs
                          depending on your filters. By clicking on one section,
                          you will have the details by project and by users.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-item">
                      <div>
                        <div className="shot-item">
                          <img
                            src="assets/img/blog/calendar.png"
                            alt=" timesheets plugin jira"
                          />
                          <div className="single-content">
                            <div className="fancy-table">
                              <div className="table-cell">
                                <div className="zoom-icon">
                                  <a
                                    className="lightbox"
                                    href="assets/img/blog/calendar.png"
                                  >
                                    <i className="lni-eye item-icon"></i>
                                  </a>
                                </div>
                                <p>Calendar</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="info">
                        <h2>
                          <p>Calendar</p>
                        </h2>
                      </div>
                      <div className="content">
                        <p className="description">
                          If you have the calendar version please go to Calendar
                          functionnality.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-item">
                      <div>
                        <div>
                          <div className="shot-item">
                            <img
                              src="assets/img/blog/create-filter.png"
                              alt=" timesheets plugin jira"
                            />
                            <div className="single-content">
                              <div className="fancy-table">
                                <div className="table-cell">
                                  <div className="zoom-icon">
                                    <a
                                      className="lightbox"
                                      href="assets/img/blog/create-filter.png"
                                    >
                                      <i className="lni-eye item-icon"></i>
                                    </a>
                                  </div>
                                  <p>Custom filter</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="info">
                        <h2>
                          <p>Custom filter</p>
                        </h2>
                      </div>
                      <div className="content">
                        <p className="description">
                          Project : By defaults, all JIRA instance projects will
                          be included, select one or more projects in thisfield.
                          You have semi automatic search to speed up your
                          selection User : If you want to add some users to your
                          request, or to exclude some of them, you have to use
                          this field. Semi automatic search helps you to find
                          your target Filter : If you just want to list
                          timesheets depending on previously saved filter on
                          your JIRA instance, you pick up that filter on this
                          field. Range : Can be weeks (- nb) starting from
                          today. Otherwise, you can define a date range.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-item">
                      <div>
                        <div>
                          <div className="shot-item">
                            <img
                              src="assets/img/blog/create-filter-day.png"
                              alt=" timesheets plugin jira"
                            />
                            <div className="single-content">
                              <div className="fancy-table">
                                <div className="table-cell">
                                  <div className="zoom-icon">
                                    <a
                                      className="lightbox"
                                      href="assets/img/blog/create-filter-day.png"
                                    >
                                      <i className="lni-eye item-icon"></i>
                                    </a>
                                  </div>
                                  <p>Display results</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="info">
                        <h2>
                          <p>Display results</p>
                        </h2>
                      </div>
                      <div className="content">
                        <p className="description">
                          Display : the results in hours or days. By default,
                          the day duration will take its value from your JIRA
                          configuration. But you can override it. You may have
                          partners that work with another day costs (8.5 hours,
                          9 hours etc..) and you can generate timesheets
                          depending on your needs. Generate charts : If you want
                          just the table, let it Off. The On mode will generate
                          dynamic pie charts to see further details (section
                          below).Remove inactive users : You can hide from
                          tables and charts users with 0 minutes of work. Turn
                          the ON button to remove those inactive users.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="testimonial-item">
                      <div>
                        <div className="shot-item">
                          <img
                            src="assets/img/blog/table.png"
                            alt=" timesheets plugin jira"
                          />
                          <div className="single-content">
                            <div className="fancy-table">
                              <div className="table-cell">
                                <div className="zoom-icon">
                                  <a
                                    className="lightbox"
                                    href="assets/img/blog/table.png"
                                  >
                                    <i className="lni-eye item-icon"></i>
                                  </a>
                                </div>
                                <p>Table</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="info">
                        <h2>
                          <p>Table</p>
                        </h2>
                      </div>
                      <div className="content">
                        <p className="description">Table customizatiom.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="portfolios" className="section-padding">
          <div className="container">
            <div id="portfolio" className="row">
              <div className="col-lg-4 col-md-6 col-xs-12 mix development print">
                <div className="portfolio-item">
                  <div className="shot-item">
                    <img
                      src="assets/img/portfolio/img-1.jpg"
                      alt=" timesheets plugin jira"
                    />
                    <div className="single-content">
                      <div className="fancy-table">
                        <div className="table-cell">
                          <div className="zoom-icon">
                            <a
                              className="lightbox"
                              href="assets/img/portfolio/img-1.jpg"
                            >
                              <i className="lni-eye item-icon"></i>
                            </a>
                          </div>
                          <a href="#">Creative Design</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-xs-12 mix design print">
                <div className="portfolio-item">
                  <div className="shot-item">
                    <img
                      src="assets/img/portfolio/img-2.jpg"
                      alt="jira plugin  timesheets marketplace"
                    />
                    <div className="single-content">
                      <div className="fancy-table">
                        <div className="table-cell">
                          <div className="zoom-icon">
                            <a
                              className="lightbox"
                              href="assets/img/portfolio/img-2.jpg"
                            >
                              <i className="lni-eye item-icon"></i>
                            </a>
                          </div>
                          <a href="#">Retina Ready</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-xs-12 mix development">
                <div className="portfolio-item">
                  <div className="shot-item">
                    <img
                      src="assets/img/portfolio/img-3.jpg"
                      alt="charts  for jira plugin timesheet"
                    />
                    <div className="single-content">
                      <div className="fancy-table">
                        <div className="table-cell">
                          <div className="zoom-icon">
                            <a
                              className="lightbox"
                              href="assets/img/portfolio/img-3.jpg"
                            >
                              <i className="lni-eye item-icon"></i>
                            </a>
                          </div>
                          <a href="#">Responsive</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-xs-12 mix development design">
                <div className="portfolio-item">
                  <div className="shot-item">
                    <img
                      src="assets/img/portfolio/img-4.jpg"
                      alt="calendar timesheets for jira free plugin"
                    />
                    <div className="single-content">
                      <div className="fancy-table">
                        <div className="table-cell">
                          <div className="zoom-icon">
                            <a
                              className="lightbox"
                              href="assets/img/portfolio/img-4.jpg"
                            >
                              <i className="lni-eye item-icon"></i>
                            </a>
                          </div>
                          <a href="#">Well Documented</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="counter" className="section-padding">
          <div className="overlay"></div>
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-lg-12 col-md-12 col-xs-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-xs-12">
                    <div
                      className="counter-box wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div className="icon-o">
                        <i className="lni-users"></i>
                      </div>
                      <div className="fact-count">
                        <h3>
                          <span className="counter">5900</span>
                        </h3>
                        <p>Companies</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-xs-12">
                    <div
                      className="counter-box wow fadeInUp"
                      data-wow-delay="0.6s"
                    >
                      <div className="icon-o">
                        <i className="lni-download"></i>
                      </div>
                      <div className="fact-count">
                        <h3>
                          <span className="counter">20000</span>
                        </h3>
                        <p>Downloads</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-xs-12">
                    <div
                      className="counter-box wow fadeInUp"
                      data-wow-delay="0.8s"
                    >
                      <div className="icon-o">
                        <i className="lni-thumbs-up"></i>
                      </div>
                      <div className="fact-count">
                        <h3>
                          <span>3.7/4</span>
                        </h3>
                        <p>Rating</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-xs-12">
                    <div
                      className="counter-box wow fadeInUp"
                      data-wow-delay="0.8s"
                    >
                      <div className="icon-o">
                        <i className="lni-timer"></i>
                      </div>
                      <div className="fact-count">
                        <h3>
                          <span>24/7</span>
                        </h3>
                        <p>Support</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/*     <section id="contact" className="section-padding">
          <div className="container">
            <h2>Contact us</h2>
            <div
              className="row contact-form-area wow fadeInUp"
              data-wow-delay="0.4s"
            >
              <div className="col-md-12 col-lg-12 col-sm-12">
                <div className="contact-block">
                  <form id="contactForm">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            placeholder="Name"
                            required
                            data-error="Please enter your name"
                            value={this.state.name}
                            onChange={(e) =>
                              this.setState({ name: e.target.value })
                            }
                          />
                          <div className="help-block with-errors"></div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            placeholder="Email"
                            id="email"
                            className="form-control"
                            name="email"
                            required
                            data-error="Please enter your email"
                            value={this.state.email}
                            onChange={(e) =>
                              this.setState({ email: e.target.value })
                            }
                          />
                          <div className="help-block with-errors"></div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            placeholder="Subject"
                            id="msg_subject"
                            className="form-control"
                            required
                            data-error="Please enter your subject"
                            value={this.state.msg_subject}
                            onChange={(e) =>
                              this.setState({ msg_subject: e.target.value })
                            }
                          />
                          <div className="help-block with-errors"></div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <textarea
                            className="form-control"
                            id="message"
                            placeholder="Your Message"
                            rows="5"
                            data-error="Write your message"
                            required
                            value={this.state.message}
                            onChange={(e) =>
                              this.setState({ message: e.target.value })
                            }
                          ></textarea>
                          <div className="help-block with-errors"></div>
                        </div>
                        <div className="submit-button">
                          <button
                            className="r-button ai-element ai-element_type3 ai-element6"
                            id="form-submit"
                            type="submit"
                            onClick={(e) => this.handleFormSubmit(e)}
                          >
                            <span className="ai-element__label">
                              Send Message
                            </span>
                          </button>

                          <div
                            id="msgSubmit"
                            className="h3 text-center hidden"
                          ></div>
                          <div className="clearfix"></div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js